module.exports = __webpack_public_path__ + "static/img/IMG_20240101_205759.2ab30e06.jpg";